var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shapes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 0.5H0.5C0.367392 0.5 0.240215 0.552679 0.146447 0.646447C0.0526785 0.740215 0 0.867392 0 1V10C0 10.1326 0.0526785 10.2598 0.146447 10.3536C0.240215 10.4473 0.367392 10.5 0.5 10.5H14.5C14.6326 10.5 14.7598 10.4473 14.8536 10.3536C14.9473 10.2598 15 10.1326 15 10V1C15 0.867392 14.9473 0.740215 14.8536 0.646447C14.7598 0.552679 14.6326 0.5 14.5 0.5ZM7.5 6.41L1.08 1.41H14.05L7.5 6.41ZM4.8 5.5L0.89 9.05V2.5L4.8 5.5ZM5.6 6.12L7.22 7.39C7.30046 7.45345 7.39787 7.49172 7.5 7.5C7.6116 7.5022 7.72073 7.467 7.81 7.4L9.41 6.17L13.22 9.6H1.75L5.6 6.12ZM10.24 5.54L14.12 2.54V9.01L10.24 5.54Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.9fd60ec6ae90486afb7d76e3a574a262.svg";
export { ForwardRef as ReactComponent };